import httpClient from '../../client'

import apiRoutes from '../constants'

const reOpenProposal = async ({id}) => {
  return await httpClient.post(`${apiRoutes.GET_PROPOSALS}/${id}/reopen`)
}

export default reOpenProposal
